import type { FileManagerToolFactory } from './fileManagerTool';
import { createOutlookMailCopyTool } from './outlook-mail/outlookMailCopyTool';

/**
 * Every tool the "Verktyg ›" submenu can offer. Adding one is a new file plus one entry here — no edits
 * to the menu builders, no edits to the call sites.
 *
 * Array order IS menu order. No priority field, no sorting, no dynamic registration: two tools do not
 * pay for any of it, and an explicit list is the thing a reader can actually check against the menu.
 *
 * Factories rather than values, because a tool's `run` closes over inject()ed state and inject() only
 * resolves during setup(). useFileManagerTools calls each of these exactly once, from there.
 */
export const TOOL_FACTORIES: FileManagerToolFactory[] = [
  createOutlookMailCopyTool,
];
